"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnauthorizedStyled = void 0;
const constants_1 = require("../../theme/constants");
exports.UnauthorizedStyled = styled.div `
display: flex;
flex-flow: column nowrap;
gap: 5em;
align-items: center;
justify-content: center;
height: 100vh;

> img.logo {
  width: 30em;
  max-width: 90vw;
}

> img.illustration {
  width: 60em;
  max-width: 90vw;
}

>.login {
  > button {
    >.text {
      @media (min-width: ${constants_1.sizes.mobile}) {
        display: flex;
      }

      @media (max-width: ${constants_1.sizes.mobile}) {
        display: none;
      }
    }
  }
}
`;
//# sourceMappingURL=Unauthorized.styled.js.map